<app-shell-admin-warning-banner></app-shell-admin-warning-banner>

<section class="changelog-admin">
	<div class="changelog-admin__topbar">
		<div>
			<p class="eyebrow">Need help?</p>
			<h5 class="section-title">Guided walkthrough</h5>
		</div>
		<dx-button text="Guided Tour" type="normal" (onClick)="startTour()"></dx-button>
	</div>
	<div class="workspace" [class.workspace--browser-hidden]="!isReleaseBrowserVisible" [class.workspace--browser-only]="isReleaseBrowserVisible && (!hasSelection || isSelectingRelease)">
		<section id="tour-release-browser" class="workspace__column workspace__column--list card release-browser" *ngIf="isReleaseBrowserVisible">
			<div class="card-body">
				<div class="release-browser__header">
					<div>
						<p class="eyebrow">Latest 50</p>
						<h5 class="section-title">Changelogs</h5>
					</div>
					<div id="tour-browser-actions" class="release-browser__actions">
						<dx-button text="Refresh List" type="normal" [disabled]="loadingOverview" (onClick)="loadOverview()"></dx-button>
						<dx-button text="Select Latest" type="normal" [disabled]="loadingOverview || overviewRows.length === 0" (onClick)="selectLatestOverviewGroup()"></dx-button>
						<dx-button text="Merge Selected" type="default" [disabled]="!canOpenSelectedRelease" (onClick)="openSelectedRelease()"></dx-button>
					</div>
				</div>

				<div class="release-browser__summary" *ngIf="overviewRows.length > 0">
					<div class="overview-state-card overview-state-card--pending">
						<strong>{{ pendingOverviewCount }}</strong>
						<span>{{ pendingOverviewCount === 1 ? 'still needs a grouped release' : 'still need grouped releases' }}</span>
					</div>
					<div class="overview-state-card overview-state-card--converted">
						<strong>{{ convertedOverviewCount }}</strong>
						<span>already converted</span>
					</div>
				</div>

				<dx-data-grid class="overview-grid" [dataSource]="overviewRows" keyExpr="selectionKey" [showBorders]="true" [hoverStateEnabled]="true" [rowAlternationEnabled]="true" [columnAutoWidth]="true" [selectedRowKeys]="selectedRowKeys" (onSelectionChanged)="onOverviewSelectionChanged($event)">
					<dxo-selection mode="multiple" showCheckBoxesMode="always" selectAllMode="page"></dxo-selection>
					<dxo-sorting mode="single"></dxo-sorting>
					<dxo-paging [pageSize]="14"></dxo-paging>
					<dxo-pager [showPageSizeSelector]="false" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>

					<dxi-column dataField="releaseFamilyName" caption="FamilyKeyName"></dxi-column>
					<dxi-column dataField="version" caption="Version" [width]="120"></dxi-column>
					<dxi-column dataField="conversionState" caption="Release State" [width]="180" cellTemplate="releaseStateTemplate"></dxi-column>
					<dxi-column dataField="workflowStatusText" caption="Workflow" [width]="120"></dxi-column>
					<dxi-column dataField="releaseDate" caption="ReleaseDate" [width]="130"></dxi-column>
					<dxi-column dataField="exportedAtUtc" caption="Date Uploaded" dataType="datetime" format="yyyy-MM-dd HH:mm" [width]="180"></dxi-column>

					<div *dxTemplate="let cell of 'releaseStateTemplate'" class="overview-state-cell">
						<span class="overview-status-pill" [ngClass]="cell.data.exists ? 'overview-status-pill--converted' : 'overview-status-pill--pending'">
							{{ cell.data.conversionState }}
						</span>
						<small>{{ cell.data.conversionHint }}</small>
					</div>
				</dx-data-grid>
			</div>
		</section>

		<section class="workspace__column workspace__column--editor card" *ngIf="hasSelection && !isSelectingRelease">
			<div class="card-body" *ngIf="selectedOverview != null && release != null && editorPayload != null">
				<section class="selected-release-banner selected-release-banner--warning" *ngIf="isDirty">
					<div class="selected-release-banner__body">
						<p class="eyebrow">Unsaved changes</p>
						<strong>Your draft has edits that are not saved yet.</strong>
						<small>Save the draft before refreshing the release or switching to a different selection.</small>
					</div>
				</section>

				<section id="tour-editor-hero" class="editor-hero">
					<div class="editor-hero__top">
						<div>
							<p class="eyebrow">Current release</p>
							<h3 class="editor-hero__title">{{ releaseDisplayTitle }}</h3>
						</div>

						<div class="editor-hero__actions">
							<dx-button text="Change Selection" type="normal" (onClick)="returnToReleaseSelection()"></dx-button>
							<dx-button text="Refresh Release" type="normal" [disabled]="selectedOverview == null || loadingEntry" (onClick)="refreshSelectedRelease()"></dx-button>
							<dx-button text="Source Workflow" type="normal" [disabled]="release == null" (onClick)="openWorkflowModal()"></dx-button>
							<dx-button text="Save Draft" type="default" [disabled]="saving || isMainEditorBlocked" (onClick)="saveDraft()"></dx-button>
							<dx-button text="Publish" type="success" [disabled]="saving || isMainEditorBlocked" (onClick)="publish()"></dx-button>
						</div>
					</div>

					<div class="editor-hero__footer">
						<div class="section-meta section-meta--chips">
							<span class="badge badge-primary">{{ release.status }}</span>

							<span class="badge badge-light" *ngIf="release.isPreRelease">Pre-release</span>
							<span class="badge badge-warning" *ngIf="isDirty">Unsaved</span>
						</div>

						<div class="focus-banner" [class.focus-banner--warning]="isDirty">
							<span class="focus-banner__label">Now</span>
							<strong>{{ activeStepTitle }}</strong>
						</div>
					</div>

					<div class="editor-hero__utility-actions">
						<dx-button text="Ready For Review" type="normal" [disabled]="saving || isMainEditorBlocked" (onClick)="markReadyForReview()"></dx-button>
						<dx-button text="Restore Published" type="normal" [disabled]="saving || isMainEditorBlocked || release.publishedPayload == null" (onClick)="restorePublishedToDraft()"></dx-button>
						<dx-button text="Archive" type="danger" [disabled]="saving || isMainEditorBlocked" (onClick)="archive()"></dx-button>
					</div>
				</section>

				<section class="workflow-strip" aria-label="Release workflow">
					<article class="workflow-step" *ngFor="let step of workflowSteps" [class.workflow-step--active]="step.isActive" [class.workflow-step--complete]="step.isComplete" [class.workflow-step--blocked]="step.isBlocked">
						<div class="workflow-step__badge">{{ step.label }}</div>
						<div class="workflow-step__body">
							<strong>{{ step.title }}</strong>
							<small>{{ step.helper }}</small>
						</div>
					</article>
				</section>


				<div class="callout callout--danger" *ngIf="release.draftPayloadParseError">
					Draft parse error: {{ release.draftPayloadParseError }}
				</div>

				<div class="callout callout--danger" *ngIf="release.publishedPayloadParseError">
					Published parse error: {{ release.publishedPayloadParseError }}
				</div>

				<div class="callout callout--warning" *ngFor="let warning of release.validationWarnings">
					<strong>{{ warning.code }}</strong>: {{ warning.message }}
				</div>



				<div class="editor-stage" [class.editor-stage--blocked]="isMainEditorBlocked">
					<div class="editor-stage__overlay" *ngIf="isMainEditorBlocked">
						<div class="editor-stage__overlay-card">
							<strong>Complete the source workflow first</strong>
							<p>The main editor stays locked until you review the selected files and apply the draft from the workflow modal.</p>
							<dx-button text="Open Source Workflow" type="default" (onClick)="openWorkflowModal()"></dx-button>
						</div>
					</div>

					<section id="release-details" class="editor-card" [class.editor-card--focus]="activeStep === 'details'" [attr.inert]="isMainEditorBlocked ? '' : null">
						<div class="section-header section-header--compact">
							<h5 class="section-title">1. Release Details</h5>
						</div>

						<div class="metadata-grid">
							<div class="field">
								<span>Release date</span>
								<dx-date-box class="form-control" type="date" [value]="releaseDateValue" displayFormat="yyyy-MM-dd" [showClearButton]="false" [useMaskBehavior]="true" [acceptCustomValue]="false" (onValueChanged)="onReleaseDateChanged($event.value)"></dx-date-box>
							</div>

							<div class="field field--wide">
								<span>Title</span>
								<input type="text" class="form-control" [(ngModel)]="editorPayload.title" (ngModelChange)="markDirty()" [placeholder]="defaultReleaseTitle" />
							</div>

							<div class="field field--wide">
								<span>Short summary</span>
								<textarea class="form-control textarea" rows="2" [(ngModel)]="editorPayload.summary" (ngModelChange)="markDirty()" placeholder="Optional short summary"></textarea>
							</div>

							<div class="field field--wide">
								<span>Source applications</span>
								<div class="chip-list">
									<span class="chip" *ngFor="let applicationKey of editorPayload.sourceApplicationKeys">{{ applicationKey }}</span>
								</div>
							</div>
						</div>
					</section>


					<section id="release-notes" class="editor-card" [class.editor-card--focus]="activeStep === 'notes'" [class.editor-card--blocked]="isNotesStepBlocked" [attr.inert]="isMainEditorBlocked || isNotesStepBlocked ? '' : null">
						<div class="editor-card__overlay" *ngIf="isNotesStepBlocked">
							<div class="editor-card__overlay-card">
								<strong>Finish release details first</strong>
								<p>Choose the release date and confirm the default title before editing the notes.</p>
							</div>
						</div>

						<div class="section-header section-header--compact">
							<h5 class="section-title">2. Release Notes</h5>
							<div class="action-row action-row--tight">
								<dx-button [text]="isDraftItemsCompact ? 'Show All Details' : 'Compact All Points'" type="normal" (onClick)="toggleDraftItemsCompact()"></dx-button>
								<dx-button text="Add Section" type="default" (onClick)="addSection()"></dx-button>
							</div>
						</div>

						<section class="draft-sections">
						<div class="draft-section card" *ngFor="let section of editorPayload.sections; let sectionIndex = index; trackBy: trackBySectionIndex" [ngClass]="getSectionToneClass(section.sectionName)">
							<div class="draft-section__banner">
								<button type="button" class="draft-section__toggle" (click)="toggleSectionExpanded(sectionIndex)">
									<span class="draft-section__title">{{ section.sectionName }}</span>
									<span class="draft-section__summary">{{ section.items.length }} {{ section.items.length === 1 ? 'entry' : 'entries' }}</span>
								</button>
								<button type="button" class="draft-section__banner-meta" (click)="toggleSectionExpanded(sectionIndex)">{{ isSectionExpanded(sectionIndex) ? 'Collapse' : 'Expand' }}</button>
							</div>

							<div class="draft-section__content" *ngIf="isSectionExpanded(sectionIndex)">
								<div class="draft-section__header">
									<label class="field field--compact">
										<span>Section type</span>
										<select class="form-control form-control--small" [ngModel]="section.sectionName" (ngModelChange)="onSectionNameChanged(section, $event)">
											<option *ngFor="let sectionName of allowedSections" [value]="sectionName">{{ sectionName }}</option>
										</select>
									</label>
									<div class="action-row action-row--tight">
										<dx-button text="Add Note" type="default" (onClick)="addItem(section)"></dx-button>
										<dx-button text="Remove Section" type="danger" (onClick)="removeSection(sectionIndex)"></dx-button>
									</div>
								</div>

								<div
									class="draft-section__items"
									cdkDropList
									[id]="getDraftSectionDropListId(sectionIndex)"
									[cdkDropListData]="section.items"
									[cdkDropListConnectedTo]="draftSectionDropListIds"
									(cdkDropListDropped)="onDraftItemDrop($event)">
									<div class="draft-section__empty-drop" *ngIf="section.items.length === 0">
										{{ draggingDraftItemId != null ? 'Drop first point here' : 'No points in this section yet.' }}
									</div>

									<div
										class="draft-item"
										*ngFor="let item of section.items; let itemIndex = index; trackBy: trackByItemId"
										cdkDrag
										[cdkDragData]="item"
										[class.draft-item--compact]="isDraftItemsCompact"
										[class.draft-item--expanded]="isDraftItemExpanded(item.id)"
										[class.draft-item--dragging]="draggingDraftItemId === item.id"
										(cdkDragStarted)="onDraftItemDragStart(item.id)"
										(cdkDragEnded)="onDraftItemDragEnd()">
										<div class="draft-item__body">
											<div class="draft-item__header">
												<div class="draft-item__heading">
													<button
														type="button"
														class="draft-item__drag-handle"
														cdkDragHandle
														[attr.aria-label]="'Drag point ' + (itemIndex + 1)"
														title="Drag point"></button>
													<span class="draft-item__label">Point {{ itemIndex + 1 }}</span>
												</div>
												<div class="draft-item__meta">
													<span class="badge badge-light" *ngIf="item.isManuallyEdited">Manual</span>
												</div>
											</div>

											<div class="draft-item__compact-summary" *ngIf="isDraftItemsCompact && !isDraftItemExpanded(item.id)">
												<p class="draft-item__compact-text">{{ getDraftItemCompactText(item) }}</p>
												<div class="draft-item__compact-meta">
													<span class="chip">{{ getApplicationSelectionSummaryText(item) }}</span>
													<span class="chip">{{ getLinkedSourceSummary(item) }}</span>
												</div>
											</div>

											<ng-container *ngIf="isDraftItemExpanded(item.id)">
												<label class="field field--wide">
													<span>What users will read</span>
													<textarea class="form-control textarea textarea--item" rows="2" [(ngModel)]="item.text" (ngModelChange)="markDirty()" placeholder="Write the user-facing changelog note here."></textarea>
												</label>

												<div class="target-apps">
													<div class="field field--wide">
														<span>Applications</span>
														<div class="selector-summary-card selector-summary-card--inline">
															<div class="selector-summary-card__top">
																<div class="selector-summary-card__text">
																	<strong>{{ getApplicationSelectionSummaryText(item) }}</strong>
																</div>
																<dx-button text="Select Applications" type="normal" (onClick)="openItemApplicationSelector(item)"></dx-button>
															</div>

															<div class="chip-list chip-list--compact" *ngIf="getItemTargetApplicationDisplayNames(item).length > 0">
																<span class="chip" *ngFor="let displayName of getItemTargetApplicationDisplayNames(item)">{{ displayName }}</span>
															</div>
														</div>
													</div>
												</div>

												<div class="draft-item__linking" [class.draft-item__linking--manual]="item.sourceReferences.length === 0">
													<div class="draft-item__linking-header">
														<span class="draft-item__linking-title">Linked source changes</span>
														<strong>{{ getLinkedSourceSummary(item) }}</strong>
													</div>

													<div class="linked-source-list" *ngIf="item.sourceReferences.length > 0; else noSourceReferences">
														<article class="linked-source" *ngFor="let reference of getResolvedSourceReferences(item); trackBy: trackBySourceReferenceKey">
															<div class="linked-source__meta">
																<span class="linked-source__pill linked-source__pill--application">{{ reference.sourceLabel }}</span>
																<span class="linked-source__pill" *ngIf="reference.versionLabel">{{ reference.versionLabel }}</span>
																<span class="linked-source__pill">{{ reference.locationLabel }}</span>
															</div>

															<p class="linked-source__text" *ngIf="reference.description">{{ reference.description }}</p>
															<p class="linked-source__text linked-source__text--placeholder" *ngIf="reference.isLoading && !reference.description">Loading original change...</p>
															<p class="linked-source__text linked-source__text--placeholder" *ngIf="!reference.isLoading && !reference.description">Original change text unavailable; this point still links to the raw source entry.</p>
															<small class="linked-source__path" *ngIf="reference.sourceFile">{{ reference.sourceFile }}</small>
														</article>
													</div>

													<ng-template #noSourceReferences>
														<p class="linked-source-empty">This point was added manually and is not linked to a raw changelog change yet.</p>
													</ng-template>
												</div>
											</ng-container>
										</div>

										<div class="draft-item__actions">
											<dx-button *ngIf="isDraftItemsCompact" [text]="isDraftItemExpanded(item.id) ? 'Close Editor' : 'Edit'" type="default" (onClick)="toggleDraftItemExpanded(item.id)"></dx-button>
											<dx-button text="Remove" type="danger" (onClick)="removeItem(section, itemIndex)"></dx-button>
										</div>

										<ng-template cdkDragPreview>
											<div class="draft-item draft-item--preview">
												<div class="draft-item__preview-header">
													<span class="draft-item__label">Point {{ itemIndex + 1 }}</span>
													<span class="badge badge-light" *ngIf="item.isManuallyEdited">Manual</span>
												</div>
												<p class="draft-item__preview-text">{{ getDraftItemCompactText(item) }}</p>
											</div>
										</ng-template>

										<ng-template cdkDragPlaceholder>
											<div class="draft-item draft-item--placeholder"></div>
										</ng-template>
									</div>
								</div>
							</div>
						</div>
						</section>
					</section>
				</div>
			</div>
		</section>

		<section class="workspace__column workspace__column--side card" *ngIf="hasSelection && !isSelectingRelease">
			<div class="card-body" *ngIf="release != null">
				<div class="editor-stage editor-stage--side" [class.editor-stage--blocked]="isMainEditorBlocked">
					<div class="editor-stage__overlay" *ngIf="isMainEditorBlocked">
						<div class="editor-stage__overlay-card editor-stage__overlay-card--compact">
							<strong>Preview unlocks after the workflow</strong>
							<p>Review the selected files first, then apply the curated draft to this screen.</p>
							<dx-button text="Open Source Workflow" type="default" (onClick)="openWorkflowModal()"></dx-button>
						</div>
					</div>

					<section id="release-preview" class="editor-card editor-card--sticky" [class.editor-card--focus]="activeStep === 'preview'" [class.editor-card--blocked]="isPreviewStepBlocked" [attr.inert]="isMainEditorBlocked || isPreviewStepBlocked ? '' : null">
						<div class="editor-card__overlay" *ngIf="isPreviewStepBlocked">
							<div class="editor-card__overlay-card">
								<strong>Preview unlocks after notes</strong>
								<p>Complete release details and add at least one note before previewing the final release.</p>
							</div>
						</div>

						<div class="section-header section-header--compact">
							<div>
								<h5 class="section-title">3. Preview</h5>
								<div class="section-meta">
									<span *ngIf="release.publishedAtUtc">{{ release.publishedAtUtc | date:'yyyy-MM-dd HH:mm' }}</span>
								</div>
							</div>
							<dx-button [text]="previewSyncButtonText" type="default" [disabled]="loadingPreview || isDirty || isMainEditorBlocked" (onClick)="refreshPreview()"></dx-button>
						</div>

						<div class="preview-settings">
							<label class="field field--compact">
								<span>Audience</span>
								<select class="form-control" [(ngModel)]="previewAudience">
									<option *ngFor="let audience of allowedPreviewAudiences" [value]="audience">{{ audience }}</option>
								</select>
							</label>

							<label class="field field--compact">
								<span>Stage</span>
								<select class="form-control" [(ngModel)]="previewStage">
									<option value="Draft">Draft</option>
									<option value="Published">Published</option>
								</select>
							</label>
						</div>

						<div class="callout" [ngClass]="isDirty ? 'callout--warning' : 'callout--info'">
							{{ previewSyncMessage }}
						</div>

						<div class="preview-panel" *ngIf="currentPreviewPayload as previewPayload; else previewPlaceholder">
							<h4>{{ previewDisplayTitle }}</h4>
							<p *ngIf="previewPayload.summary">{{ previewPayload.summary }}</p>

							<div class="callout callout--warning" *ngFor="let warning of currentPreviewWarnings">
								<strong>{{ warning.code }}</strong>: {{ warning.message }}
							</div>

							<div class="preview-section" *ngFor="let section of previewPayload.sections">
								<h6>{{ section.sectionName }}</h6>
								<ul>
									<li *ngFor="let item of section.items">
										<span>{{ item.text }}</span>
										<span class="inline-meta">{{ item.scope }}</span>
										<span class="inline-meta" *ngIf="item.targetApplicationKeys.length > 0">{{ item.targetApplicationKeys.join(', ') }}</span>
									</li>
								</ul>
							</div>
						</div>

						<ng-template #previewPlaceholder>
							<div class="callout callout--info">No preview available.</div>
						</ng-template>
					</section>
				</div>
			</div>
		</section>
	</div>

	<div class="selector-modal-backdrop selector-modal-backdrop--workflow" *ngIf="isWorkflowModalOpen && hasSelection">
		<section class="selector-modal selector-modal--workflow card" (click)="$event.stopPropagation()">
			<div class="selector-modal__header">
				<div>
					<p class="eyebrow">Source workflow</p>
					<h5 class="section-title">Prepare Release Notes Before Editing</h5>
				</div>
				<button type="button" class="selector-modal__close" (click)="closeWorkflowModal()">&times;</button>
			</div>

			<div class="selector-modal__toolbar selector-modal__toolbar--workflow">
				<div class="workflow-modal__steps">
					<span class="workflow-modal__step" [class.workflow-modal__step--active]="workflowModalStep === 'select'">1. Select files</span>
					<span class="workflow-modal__step" [class.workflow-modal__step--active]="workflowModalStep === 'review'">2. Review per file</span>
					<span class="workflow-modal__step" [class.workflow-modal__step--active]="workflowModalStep === 'confirm'">3. Confirm draft</span>
				</div>
				<div class="workflow-modal__summary">
					<strong>{{ sourceFileWorkflowSummaryText }}</strong>
					<small>{{ workflowIncludedItemCount === 1 ? '1 point currently included' : workflowIncludedItemCount + ' points currently included' }}</small>
				</div>
			</div>

			<div class="selector-modal__body">
				<div [ngSwitch]="workflowModalStep">
					<ng-container *ngSwitchCase="'select'">
						<p class="workflow-intro">Choose which raw changelog files belong in this deployment. Only the selected files will move into the review flow.</p>

						<div class="source-file-toolbar">
							<label class="field">
								<span>Search source files</span>
								<input type="text" class="form-control" [(ngModel)]="sourceFileSearch" placeholder="Search by file name, app, or note text" />
							</label>

							<div class="source-file-summary-card">
								<strong>{{ sourceFileWorkflowSummaryText }}</strong>
								<small>{{ totalSourceFileCount === 0 ? 'This release did not expose file-level references.' : 'You can still change the final wording in the next step.' }}</small>
							</div>
						</div>

						<div class="source-file-groups" *ngIf="filteredSourceFileGroups.length > 0; else noWorkflowSourceFiles">
							<label class="source-file-card" *ngFor="let group of filteredSourceFileGroups; trackBy: trackBySourceFileKey" [class.source-file-card--selected]="isSourceFileSelected(group.key)">
								<div class="source-file-card__selector">
									<input type="checkbox" [checked]="isSourceFileSelected(group.key)" (change)="toggleSourceFileSelection(group.key, $any($event.target).checked)" />
								</div>

								<div class="source-file-card__body">
									<div class="source-file-card__header">
										<div>
											<strong>{{ getWorkflowSourceCardHeading(group) }}</strong>
											<small>{{ group.sourceFile }}</small>
										</div>

										<div class="source-file-card__meta">
											<span class="chip">{{ group.sourceApplicationName }}</span>
											<span class="chip" *ngIf="group.versionLabel">{{ group.versionLabel }}</span>
											<span class="chip">{{ group.pointCount }} {{ group.pointCount === 1 ? 'point' : 'points' }}</span>
										</div>
									</div>

									<p class="source-file-card__sections">{{ group.sectionSummary }}</p>

									<ul class="source-file-card__preview">
										<li *ngFor="let previewItem of group.items | slice:0:3">
											<strong>{{ previewItem.sectionName }}:</strong> {{ previewItem.text }}
										</li>
									</ul>

									<p class="source-file-card__more" *ngIf="group.items.length > 3">+{{ group.items.length - 3 }} more linked points</p>
								</div>
							</label>
						</div>

						<ng-template #noWorkflowSourceFiles>
							<div class="callout callout--info">
								{{ totalSourceFileCount === 0 ? 'No source files are available for this release.' : 'No source files match your search.' }}
							</div>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'review'">
						<ng-container *ngIf="currentWorkflowReviewGroup as group; else noWorkflowReview">
							<div class="workflow-review__header">
								<div class="workflow-review__heading">
									<p class="eyebrow">File {{ workflowReviewFileIndex + 1 }} of {{ workflowSelectedSourceFileGroups.length }}</p>
									<h6 class="section-title">{{ getWorkflowReviewHeading(group) }}</h6>
									<p class="workflow-review__file-name" *ngIf="getWorkflowReviewHeading(group) !== group.fileName">{{ group.fileName }}</p>
									<div class="workflow-review__meta">
										<span class="chip">{{ group.sourceApplicationName }}</span>
										<span class="chip" *ngIf="group.versionLabel">{{ group.versionLabel }}</span>
										<span class="chip">{{ getWorkflowReviewSelectedPointCount(group) }}/{{ group.items.length }} selected</span>
									</div>
									<p class="muted">{{ group.sourceFile }}</p>
								</div>

								<div class="action-row action-row--tight">
									<dx-button text="Select All In File" type="normal" (onClick)="includeAllItemsForCurrentWorkflowFile()"></dx-button>
									<dx-button text="Clear All In File" type="normal" (onClick)="clearAllItemsForCurrentWorkflowFile()"></dx-button>
								</div>
							</div>

							<p class="workflow-intro">Keep the points you want from this file, rewrite the wording where needed, and then continue to the next file.</p>

							<div class="workflow-review-layout">
								<aside class="workflow-review-source">
									<div class="workflow-review-source__header">
										<strong>Source markdown</strong>
										<small>The original `.md` content for this file</small>
									</div>

									<pre class="workflow-review-source__markdown" *ngIf="getWorkflowReviewMarkdown(group) as markdown; else noWorkflowMarkdown">{{ markdown }}</pre>

									<ng-template #noWorkflowMarkdown>
										<div class="callout" [class.callout--info]="isWorkflowReviewMarkdownLoading(group)" [class.callout--warning]="!isWorkflowReviewMarkdownLoading(group)">
											{{ getWorkflowReviewMarkdownStatusText(group) }}
										</div>
									</ng-template>
								</aside>

								<div class="workflow-review-items">
									<article class="workflow-review-item" *ngFor="let item of group.items; let itemIndex = index" [class.workflow-review-item--excluded]="!item.included">
										<div class="workflow-review-item__top">
											<label class="workflow-review-item__toggle">
												<input type="checkbox" [(ngModel)]="item.included" />
												<span>Point {{ itemIndex + 1 }}</span>
											</label>
											<div class="workflow-review-item__meta">
												<span class="workflow-review-item__refs">{{ getWorkflowReferenceSummary(item) }}</span>
											</div>
										</div>

										<textarea
											class="form-control textarea textarea--workflow-review"
											rows="2"
											[(ngModel)]="item.text"
											[attr.aria-label]="'Description for point ' + (itemIndex + 1)"
											placeholder="Adjust the user-facing changelog point if needed."
										></textarea>

										<div class="workflow-review-item__controls">
											<label class="field field--compact">
												<span>Type</span>
												<select class="form-control form-control--small" [(ngModel)]="item.sectionName">
													<option *ngFor="let sectionName of allowedSections" [value]="sectionName">{{ sectionName }}</option>
												</select>
											</label>

											<div class="field field--wide">
												<span>Applications</span>
												<div class="selector-summary-card selector-summary-card--inline">
													<div class="selector-summary-card__top">
														<div class="selector-summary-card__text">
															<strong>{{ getApplicationSelectionSummaryText(item) }}</strong>
														</div>
														<dx-button text="Select Applications" type="normal" (onClick)="openWorkflowItemApplicationSelector(item)"></dx-button>
													</div>

													<div class="chip-list chip-list--compact" *ngIf="getItemTargetApplicationDisplayNames(item).length > 0">
														<span class="chip" *ngFor="let displayName of getItemTargetApplicationDisplayNames(item)">{{ displayName }}</span>
													</div>
												</div>
											</div>
										</div>

										<div class="workflow-review-item__original" *ngIf="item.text.trim() !== item.originalText.trim()">
											<span>Original suggestion</span>
											<small>{{ item.originalText }}</small>
										</div>
									</article>
								</div>
							</div>
						</ng-container>

						<ng-template #noWorkflowReview>
							<div class="callout callout--info">Select at least one source file before starting the review.</div>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'confirm'">
						<div class="workflow-confirm">
							<p class="workflow-intro">Confirm the combined result below. If anything looks off, go back to the file review step and adjust it before sending it into the main editor.</p>

							<div class="workflow-confirm__summary">
								<div class="overview-state-card overview-state-card--converted">
									<strong>{{ selectedSourceFileCount }}</strong>
									<span>{{ selectedSourceFileCount === 1 ? 'source file selected' : 'source files selected' }}</span>
								</div>
								<div class="overview-state-card overview-state-card--pending">
									<strong>{{ workflowIncludedItemCount }}</strong>
									<span>{{ workflowIncludedItemCount === 1 ? 'point included in the draft' : 'points included in the draft' }}</span>
								</div>
							</div>

							<div class="workflow-confirm__sections" *ngIf="workflowConfirmSections.length > 0; else noWorkflowConfirmItems">
								<section class="preview-section" *ngFor="let section of workflowConfirmSections">
									<h6>{{ section.sectionName }}</h6>
									<ul>
										<li *ngFor="let item of section.items">
											<span>{{ item.text }}</span>
											<small class="inline-meta" *ngIf="item.sourceReferences.length > 0">{{ item.sourceReferences[0].sourceFile }}</small>
										</li>
									</ul>
								</section>
							</div>

							<ng-template #noWorkflowConfirmItems>
								<div class="callout callout--warning">No points are currently selected. Go back and include at least one item.</div>
							</ng-template>
						</div>
					</ng-container>
				</div>
			</div>

			<div class="selector-modal__footer">
				<ng-container [ngSwitch]="workflowModalStep">
					<ng-container *ngSwitchCase="'select'">
						<dx-button text="Close" type="normal" (onClick)="closeWorkflowModal()"></dx-button>
						<dx-button text="Select All" type="normal" [disabled]="totalSourceFileCount === 0" (onClick)="selectAllSourceFiles()"></dx-button>
						<dx-button text="Continue To Review" type="default" [disabled]="!canStartWorkflowReview" (onClick)="startWorkflowReview()"></dx-button>
					</ng-container>

					<ng-container *ngSwitchCase="'review'">
						<dx-button text="Back To File Selection" type="normal" (onClick)="backToWorkflowSelection()"></dx-button>
						<dx-button text="Previous File" type="normal" [disabled]="workflowReviewFileIndex === 0" (onClick)="goToPreviousWorkflowReview()"></dx-button>
						<dx-button *ngIf="workflowReviewFileIndex < workflowSelectedSourceFileGroups.length - 1" text="Next File" type="default" (onClick)="goToNextWorkflowReview()"></dx-button>
						<dx-button *ngIf="workflowReviewFileIndex >= workflowSelectedSourceFileGroups.length - 1" text="Review Summary" type="default" (onClick)="openWorkflowConfirm()"></dx-button>
					</ng-container>

					<ng-container *ngSwitchCase="'confirm'">
						<dx-button text="Back To Reviews" type="normal" (onClick)="backToWorkflowReview()"></dx-button>
						<dx-button text="Apply To Main Editor" type="default" [disabled]="workflowIncludedItemCount === 0" (onClick)="applyWorkflowToMainEditor()"></dx-button>
					</ng-container>
				</ng-container>
			</div>
		</section>
	</div>

	<div class="selector-modal-backdrop" *ngIf="itemApplicationSelectorItem != null" (click)="cancelItemApplicationSelector()">
		<section class="selector-modal selector-modal--small card" (click)="$event.stopPropagation()">
			<div class="selector-modal__header">
				<div>
					<p class="eyebrow">Changelog item</p>
					<h5 class="section-title">Select applications</h5>
				</div>
				<button type="button" class="selector-modal__close" (click)="cancelItemApplicationSelector()">&times;</button>
			</div>

			<div class="selector-modal__toolbar selector-modal__toolbar--search">
				<label class="field field--wide">
					<span>Search</span>
					<input type="text" class="form-control" [(ngModel)]="itemApplicationSearch" placeholder="Search applications" />
				</label>
			</div>

			<div class="selector-modal__body">
				<div class="selector-modal__summary">
					<strong>{{ draftItemApplicationKeys.length }}</strong>
					<span>selected</span>
				</div>

				<div class="selector-list selector-list--single" *ngIf="filteredItemApplications.length > 0; else noItemApplications">
					<label class="selector-list__item selector-list__item--application" *ngFor="let application of filteredItemApplications; trackBy: trackByApplicationKey">
						<input
							type="checkbox"
							[checked]="isDraftItemApplicationSelected(application.applicationKey)"
							(change)="toggleItemApplicationDraft(application.applicationKey, $any($event.target).checked)"
						/>
						<span class="selector-list__content selector-list__content--application">
							<strong>{{ application.displayName }}</strong>
							<small *ngIf="application.displayName !== application.applicationKey">{{ application.applicationKey }}</small>
						</span>
					</label>
				</div>

				<ng-template #noItemApplications>
					<div class="callout callout--info">No applications match this search.</div>
				</ng-template>
			</div>

			<div class="selector-modal__footer">
				<dx-button text="Clear Applications" type="normal" [disabled]="draftItemApplicationKeys.length === 0" (onClick)="clearItemApplicationDraft()"></dx-button>
				<dx-button text="Cancel" type="normal" (onClick)="cancelItemApplicationSelector()"></dx-button>
				<dx-button text="Apply Selection" type="default" (onClick)="applyItemApplicationSelector()"></dx-button>
			</div>
		</section>
	</div>

	<app-tour-overlay></app-tour-overlay>
</section>

